module.exports = __webpack_public_path__ + "img/mindful2.aa2d3f6.svg";